var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86918 2.65584H14.2859L9.0671 9.21834L3.86918 2.65584ZM1.0046 2.24959C3.10877 4.94751 6.99418 9.94751 6.99418 9.94751V16.1975C6.99418 16.7704 7.46293 17.2392 8.03585 17.2392H10.1192C10.6921 17.2392 11.1609 16.7704 11.1609 16.1975V9.94751C11.1609 9.94751 15.0358 4.94751 17.14 2.24959C17.6713 1.56209 17.1817 0.57251 16.3171 0.57251H1.82752C0.962934 0.57251 0.47335 1.56209 1.0046 2.24959Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.90a4a88c28e019d794c3519c735e175e.svg";
export { ForwardRef as ReactComponent };